import React, {useCallback, useContext, useEffect, useState} from 'react';
import CommandsContext from '../../../context/commandsContext';
import useKeyPress from '../../../hooks/useKeyPress';
import {useMenu} from '../../../hooks/useMenu';
import BodyContentView from '../../views/bodyContentView';
import ManualEntry from './manual';

function ZeroApplied({onExit, initiallyDisableKeypress}) {
  const leftPress = useKeyPress('ArrowLeft');
  const rightPress = useKeyPress('ArrowRight');
  const {onComponent} = useMenu();
  const [isKeypressDisabled, setIsKeypressDisabled] = useState(initiallyDisableKeypress);
  const {onUpdateCommands} = useContext(CommandsContext);

  const onLeft = useCallback(() => {
    onComponent(<ManualEntry />);
  }, []);

  useEffect(() => {
    if (!leftPress || isKeypressDisabled) return;
    onLeft();
  }, [leftPress]);

  useEffect(() => {
    if (!rightPress || isKeypressDisabled) return;

    onExit();
  }, [rightPress]);

  useEffect(() => {
    onUpdateCommands({onLeft, onRight: onExit});
  }, [onLeft, onExit]);

  useEffect(() => {
    if (!initiallyDisableKeypress) return;

    setTimeout(() => {
      setIsKeypressDisabled(false);
    }, 500);
  }, []);

  return (
    <BodyContentView
      title="Zero Applied"
      left="Cancel"
      right="Finished"
      caption="Zero has been applied."
    />
  );
}

export default ZeroApplied;
